import React, { useContext }  from "react";
import { Context } from "./components/Layout";
import { NavLink, Link } from "react-router-dom";
//import Profile from "./pages/profile/Profile";
import { Navbar, Container, Image, NavDropdown, Nav, Button } from "react-bootstrap";

import { getUser, useUserActions } from "./hooks/user.actions";
import profile from "./photos/profile.jpg"
import { msalInstance, logout } from "./helpers/msal";
import { isSuperAdmin } from "./helpers/user.js";
import {variables} from './Variables.js';
import { refreshMaterializedView } from "./helpers/helpers.js";
import RefreshViewButton from "./components/RefreshViewButton/RefreshViewButton.jsx";
import axiosService from "./helpers/axios";
import { handleLogout } from "./pages/Login";
import { useSatellite, SATELLITE_ALL, SATELLITE_LEO, SATELLITE_GEO } from "./context/SatelliteContext";


import './styles.css';

function MyPage() {

  const { setToaster } = useContext(Context);

  const userActions = useUserActions();

  const user = getUser();

  const { satellite, setSatellite } = useSatellite();


  const budgetUpdateClick = () => {
    axiosService.post('/budgetupdate/', {
      updatename: "budgetupdate"
    })
    .then(result => {
      alert('Budget update');
    })
    .catch(error => {
      alert('Failed: ' + (error?.response?.data?.error || error?.message || 'Unknown error'));
    });
  };
  

  return (
    <div className="scrollable-container-app">
      <nav className="navbar navbar-expand-sm bg-light navbar-dark">
        <ul className="navbar-nav">
          <li className="nav-item m-1">
            <NavLink to="/dashboard" className="btn btn-light btn-outline-primary" activeClassName="active"
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              
              Dashboard
            </NavLink>
          </li>
          <li className="nav-item m-1">
            <NavLink to="/warehouses" className="btn btn-light btn-outline-primary" activeClassName="active"
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Warehouses
            </NavLink>
          </li>
          <li className="nav-item m-1">
            <NavLink to="/inputs" className="btn btn-light btn-outline-primary" activeClassName="active"
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Inputs
            </NavLink>
          </li>
          <li className="nav-item m-1">
            <NavLink to="/parameters" className="btn btn-light btn-outline-primary" activeClassName="active"
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              Parameters
            </NavLink>
          </li>
          <li className="nav-item m-1">
            <NavLink to="/generalparams" className="btn btn-light btn-outline-primary" activeClassName="active"
            style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
            >
              General Params
            </NavLink>
          </li>
          {/* <li className="nav-item m-1">
                <button type="button"
                  disabled={!isSuperAdmin()}
                  onClick={budgetUpdateClick}
                  className="btn-blue"
                  style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
                >
                  Update Budget
                </button>
          </li> */}
          <li className="nav-item m-1">
            <RefreshViewButton button_text="Refresh data" isAllViews={true} />
          </li>
          <li className="nav-item m-1">
            <RefreshViewButton button_text="Quick refresh" isAllViews={false} />
          </li>
          <li className="nav-item m-1">
            <div className="btn-group" role="group" aria-label="Satellite filter">
              <button
                type="button"
                className={`btn btn-light btn-outline-primary ${satellite === SATELLITE_ALL ? "active" : ""}`}
                style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
                onClick={() => setSatellite(SATELLITE_ALL)}
              >
                All
              </button>
              <button
                type="button"
                className={`btn btn-light btn-outline-primary ${satellite === SATELLITE_LEO ? "active" : ""}`}
                style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
                onClick={() => setSatellite(SATELLITE_LEO)}
              >
                LEO
              </button>
              <button
                type="button"
                className={`btn btn-light btn-outline-primary ${satellite === SATELLITE_GEO ? "active" : ""}`}
                style={{ height: "28px", fontSize: "12px", textAlign: "center" }}
                onClick={() => setSatellite(SATELLITE_GEO)}
              >
                GEO
              </button>
            </div>
          </li>
        </ul>
        <h1 className="stock-procurement-text">
        Purchase Plan Tool</h1>
        <Button variant="danger" style={{marginLeft: "2em"}} onClick={async ()=>{await handleLogout()}}>Logout</Button>
      </nav>

    </div>
  );
}

export default MyPage;

